package br.com.texeratx.boardgametimeapp.ui.screens.players

enum class PlayerSortOption {
    NAME_ASC,
    NAME_DESC
}
